// the hero is meant to end exactly at the fold, so the stage has to know how
// tall the header + salebar above it are and how much the stats row below it
// takes on mobile. both vary with viewport width, so they are measured.
class HeroBenchmark extends HTMLElement {
  connectedCallback() {
    this.stage = this.querySelector('.hero-benchmark__stage');
    this.stats = this.querySelector('.hero-benchmark__stats');
    this.measure = this.measure.bind(this);

    this.measure();
    window.addEventListener('resize', this.measure, { passive: true });
    window.addEventListener('orientationchange', this.measure);

    if ('ResizeObserver' in window) {
      this.observer = new ResizeObserver(this.measure);
      this.elementsAbove().forEach((element) => this.observer.observe(element));
    }
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.measure);
    window.removeEventListener('orientationchange', this.measure);
    if (this.observer) this.observer.disconnect();
  }

  // everything rendered before the hero in document order, at any depth, so a
  // sticky header or a salebar that grows on wrap re-triggers the measurement
  elementsAbove() {
    const elements = [];
    let node = this;

    while (node && node !== document.body) {
      let sibling = node.previousElementSibling;
      while (sibling) {
        elements.push(sibling);
        sibling = sibling.previousElementSibling;
      }
      node = node.parentElement;
    }

    return elements;
  }

  measure() {
    if (!this.stage) return;

    // rect.top + scrollY breaks while the shared scroll lock holds <body> at
    // position:fixed;top:-Npx: scrollY reads 0, so the sum collapses to 0.
    // iOS Safari fires a resize mid-lock when its toolbar re-expands (the
    // lock zeroes the scroll offset), which re-ran this with the broken sum,
    // grew the hero by the chrome height and left the close restore offset -
    // the mid-scroll hamburger 'jump'. Measuring against the body's own box
    // gives the true document offset in both states.
    const chrome = Math.max(
      0,
      Math.round(this.getBoundingClientRect().top - document.body.getBoundingClientRect().top)
    );
    this.style.setProperty('--bm-hero-chrome', `${chrome}px`);

    if (!this.stats) return;

    // on desktop the stats sit inside the stage, so this collapses to 0
    const below = this.stats.getBoundingClientRect().bottom - this.stage.getBoundingClientRect().bottom;
    this.style.setProperty('--bm-hero-extra', `${Math.max(0, Math.round(below))}px`);
  }
}

if (!customElements.get('hero-benchmark')) {
  customElements.define('hero-benchmark', HeroBenchmark);
}
